/** Maps Firebase / network errors to i18n keys under `errors.*` — never expose raw messages in UI. */
export type FriendlyErrorCode = 'permissionDenied' | 'network' | 'unavailable' | 'blocked' | 'generic';

export function isTimeoutError(error: unknown): boolean {
  const code = String((error as { code?: string })?.code ?? '');
  const msg = error instanceof Error ? error.message : String(error ?? '');
  return code === 'timeout' || /timed out/i.test(msg);
}

export function getOnboardingErrorKey(_action: 'createOrganization', error: unknown): string {
  if (isTimeoutError(error)) return 'errors.blocked';
  const code = getFriendlyErrorCode(error);
  if (code === 'blocked') return 'errors.blocked';
  if (code === 'network') return 'errors.network';
  if (code === 'unavailable') return 'errors.unavailable';
  return 'onboarding.createFailed';
}

export function getOrgLoadErrorKey(code: FriendlyErrorCode): string {
  if (code === 'blocked') return 'errors.blocked';
  if (code === 'network') return 'errors.network';
  if (code === 'unavailable') return 'errors.unavailable';
  if (code === 'permissionDenied') return 'errors.permissionDenied';
  return 'errors.generic';
}

export function getFriendlyErrorCode(error: unknown): FriendlyErrorCode {
  const msg = error instanceof Error ? error.message : String(error ?? '');
  const code = String((error as { code?: string })?.code ?? '');

  if (isTimeoutError(error)) return 'blocked';
  if (/permission|PERMISSION_DENIED|insufficient permissions/i.test(`${msg} ${code}`)) {
    return 'permissionDenied';
  }
  if (/network|offline|Failed to fetch|unavailable/i.test(`${msg} ${code}`)) {
    return 'network';
  }
  if (/unavailable|deadline/i.test(`${msg} ${code}`)) {
    return 'unavailable';
  }
  return 'generic';
}
